import { useEffect, useState } from "react"
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { getReuniones, getProyectos, setReunion, updateReunion } from '../componentes/api.js';
import Alert from '@mui/material/Alert';
import BarraBotones from "../comun/BarraBotones.jsx";
import TextField from '@mui/material/TextField';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
//import Sala from '../comun/SalaVideo.jsx'
import Table from 'react-bootstrap/Table';


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));



const SalaAdmon =(props)=>{
  let idUsuario = props.idUsuario
  const [reuniones, setReuniones] = useState([]);
  const [datos, setDatos] = useState({
    id:'',
    nbre:'',
    fecha:'',
    hora:'',
    activo:true,
    idProyecto:'',
    idUsuario:idUsuario
  });
  
  useEffect(()=>{
    if(props.idProyecto!==''){
      cargarReuniones();
    }
    
  },[props.idProyecto])
  
  const asignarDato =(event)=>{
    event.preventDefault();
    if(event.target.name==='activo'){
      setDatos({...datos, [event.target.name]: event.target.checked})

    }else{
      setDatos({...datos, [event.target.name]: event.target.value})
    }
    
  }

  const botones=(btn)=>{
    if(btn===0){ nuevo();
    }else if(btn===1){ validarDatos();
    }else if(btn===2){ imprimir();
    }else if(btn===3){ exportar();
    }else if(btn===4){ nuevo();}
  }

  const cargarReuniones=async()=>{
    try {
      const response = await getReuniones(props.idProyecto)
      setReuniones(response.data)
      

    } catch (error) {
      props.mostrarMsg(["ERROR", "Ocurrio un error al Autenticarse!", error])
    }
  }

  
  const exportar =()=>{
    props.mostrarMsg(["OK, exportará los datos"])
  }

  const grabarRegistro = async()=>{
    try {
      const response = await setReunion(datos)
      cargarReuniones(datos.idProyecto);
      props.mostrarMsg(["Felicidades!!!", "Se ha creado la Reunión"])
            
    } catch (error) {
      props.mostrarMsg(["ERROR", "Ocurrio un error al Grabar la Reunión para al Proyecto ", error])
    }
  }


  const imprimir =()=>{
    props.mostrarMsg(["OK, Imprime los datos"])
  }

 /*  const ingresarSala=(event)=>{
    event.preventDefault();
    console.log("Ingresa a sala de reunion")
    return(<>
      window.open("http://localhost", '_blank')
      <Sala 
        idUsuario={idUsuario} 
        nbres={props.nbres} 
        tipoUsuario={props.tipoUsuario} 
        socket={props.socket} 
      />
      </>
    )
  } */

  const mostrarDatos=(event, reg)=>{
    event.preventDefault()
    setDatos({...datos,
      id:reg.Id,
      nbre:reg.Nbre,
      fecha:reg.Fecha.toString().substring(0,10),
      hora:reg.Hora.toString().substring(0,5),
      activo:reg.Activo===1 ? true:false,
      idProyecto:datos.idProyecto,
      idUsuario:idUsuario
    })
  }

  const modificarRegistro = async()=>{
    try {
      const response = await updateReunion(datos)
      cargarReuniones(datos.idProyecto);
      props.mostrarMsg(["Felicidades!!!", "Se ha modificado la Reunión"])
            
    } catch (error) {
      props.mostrarMsg(["ERROR", "Ocurrio un error al Modificar la Reunión para al Proyecto ", error])
    }
  }

  const mostrarEstado=(estado, activo)=>{
    let msg=''
    if(estado===0 && activo===0) msg = "ANULADA"
    else if(estado===0 && activo===1) msg = "Pendiente - Activa"
    else if(estado===1 && activo===0) msg = "ANULADA"
    else if(estado===1 && activo===1) msg = "Ejecutada"
    return(msg)
  }

  const nuevo=()=>{
    setDatos({
      id:'',
      nbre:'',
      fecha:'',
      hora:'',
      activo:true,
      idProyecto: datos.idProyecto,
      idUsuario:idUsuario
    })
  }

  const validarDatos = ()=>{
    if(datos.idProyecto===''){
      props.mostrarMsg(["Por favor Seleccione un Proyecto!"])

    }else if(datos.nbre===''){
      props.mostrarMsg(["Por favor digite el nombre de la Reunión!"])

    }else if(datos.fecha===''){
      props.mostrarMsg(["Por favor seleccione una Fecha para la Reunión!"])

    }else if(datos.hora===''){
      props.mostrarMsg(["Por favor seleccione una Hora para la Reunión!"])

    }else{
      datos.id==='' ? grabarRegistro(): modificarRegistro(datos)
    }

  }

  return(
    <div className="container" id="divTop">
      <div className="row mt-3 mb-3">
        <Stack sx={{ width: '100%' }} spacing={2}>
          <Alert severity="success"><strong>ADMINISTRACION DE SALAS DE REUNION</strong></Alert>
        </Stack>
      </div>

      <div className="row">
        {/* {mostrarPantalla()} */}
        
      </div>

      

      <div className="row mt-3 mb-3">
        <div className="col-sm-4">
          <TextField
            style={{ marginTop: '10px' }}
            InputLabelProps={{ shrink: true }}
            name="nbre"
            label="Nombre de la Reunión"
            className="form-control"
            onChange={(event) => asignarDato(event)}
            type="text"
            value={datos.nbre}
          />
        </div>

        <div className="col-sm-4">
          <TextField
            style={{ marginTop: '10px' }}
            InputLabelProps={{ shrink: true }}
            name="fecha"
            label="Fecha de la Reunión"
            className="form-control"
            onChange={(event) => asignarDato(event)}
            type="date"
            value={datos.fecha}
          />
        </div>
        
        <div className="col-sm-4">
          <TextField
            style={{ marginTop: '10px' }}
            InputLabelProps={{ shrink: true }}
            name="hora"
            label="Hora de la Reunión"
            className="form-control"
            onChange={(event) => asignarDato(event)}
            type="time"
            value={datos.hora}
          />
        </div>
      </div>

      <div className="row">
        <FormGroup>
          <FormControlLabel 
            name="activo"
            control={
              <Switch
                checked={datos.activo}
                onChange={asignarDato}
                inputProps={{ 'aria-label': 'Activo' }} 
              />
             
            } 
            label="Estado"
            labelPlacement="start"
          />
        </FormGroup>
      </div>  

      <div className="row mt-3">
        <BarraBotones botones={botones} btnActivos={[true, true, false, true, true]}/>
      </div>

      <div className="row card mx-2 mb-3">
        <Table className="table table-hover caption-top" responsive>
          <caption className="mx-2"><strong><Alert>Listado de reuniones programadas</Alert></strong></caption>
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Fecha</th>
              <th scope="col">Hora</th>
              <th scope="col">Nombre de la Reunión</th>
              <th scope="col">Estado</th>
              <th scope="col">Acción</th>
            </tr>
          </thead>
          <tbody>
            {reuniones!==undefined && reuniones.length > 0 && reuniones.map((reg, index) => {
              return(
                <tr key={reg.Id}>
                  <th>{index + 1}</th>
                  <th>{reg.Fecha.substring(0,10)}</th>
                  <th>{reg.Hora.substring(0,5)}</th>
                  <th>{reg.Nbre}</th>
                  <th>{mostrarEstado(reg.Estado, reg.Activo)}</th>
                  <th> 
                    {reg.Estado===0 &&
                      <a href="#divTop">
                        <button 
                          className="btn btn-secondary form-control"
                          onClick={(event) => mostrarDatos(event, reg)}
                        >Editar
                        </button>
                      </a>
                    }
                  
                  </th>
                </tr>
              )
            })}
          </tbody>
        </Table>
      </div>
    </div>
   
  )
}

export default SalaAdmon